import React from 'react';
import OrderPage from '../../OrderPage';
import OrderDetails from '../OrderDetails';
import { OrderTarget } from '../../../components/OrdersTable/interfaces/OrderStatus.interface';

const TransporterOrderPage: React.FC = () => (
	<OrderPage
		target={OrderTarget.transporter}
		renderDetails={({ order, isOpen, onBack }) => (
			<OrderDetails
				key={order.id}
				isOpen={isOpen}
				selectedOrder={order}
				position="relative"
				onBack={onBack}
				hideMap
			/>
		)}
	/>
);

export default TransporterOrderPage;
